import useClientState from '@/state/useClientState';

/** Selects a werklijn and opens the matching inzet in the detail panel: the deeltraject whose
 * wleId matches the given werklijnElementId, falling back to the werklijn's first inzet.
 *
 * The actual logic lives in the `openWerklijnInMwd` store action (see dialogStoreCreator),
 * so it can compose the other store actions/state via a single `get()` call. */
export async function openWerklijnInMwd(werklijnId: string, werklijnElementId?: string) {
  await useClientState.getState().openWerklijnInMwd(werklijnId, werklijnElementId);
}
